import { Avatar, Tooltip } from "@mui/material"
import { memo, useMemo } from "react"

import type { User } from "@/graphql/codegen/graphql"

const MAX_VISIBLE_MANAGERS = 5

type Manager = Pick<User, "userId" | "name">

const formatInitials = ({ name }: Manager) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0].toUpperCase())
    .join("")

export const ManagersCell = memo(({ managers }: { managers: Manager[] }) => {
  const uniqueManagers = useMemo(
    () => [...new Map(managers.map((manager) => [manager.userId, manager])).values()],
    [managers]
  )

  if (!uniqueManagers.length) {
    return null
  }

  const extraManagersCount = uniqueManagers.length - MAX_VISIBLE_MANAGERS

  return (
    <div className='flex items-center gap-0.5'>
      {uniqueManagers.slice(0, MAX_VISIBLE_MANAGERS).map((manager) => (
        <Tooltip key={manager.userId} title={manager.name}>
          <Avatar className='size-6 bg-primary-300 text-xs'>{formatInitials(manager)}</Avatar>
        </Tooltip>
      ))}
      {extraManagersCount > 0 && (
        <Tooltip title={`${extraManagersCount} more`}>
          <Avatar className='size-6 bg-primary-300 text-xs'>+{extraManagersCount}</Avatar>
        </Tooltip>
      )}
    </div>
  )
})

ManagersCell.displayName = "ManagersCell"
